import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ea3d3c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metrics-container" }
const _hoisted_2 = { class: "tiles-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-25" }, null, -1))
const _hoisted_4 = { class: "tiles-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Acceptance Rate Average", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_7 = { class: "text-h4" }
const _hoisted_8 = { class: "tiles-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Cumulative Number of Suggestions", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_12 = { class: "text-h4" }
const _hoisted_13 = { class: "tiles-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Cumulative Number of Accepted Prompts", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_17 = { class: "text-h4" }
const _hoisted_18 = { class: "tiles-text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Cumulative Number of Lines of Code Accepted", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_22 = { class: "text-h4" }
const _hoisted_23 = { class: "chart-wrapper" }
const _hoisted_24 = { class: "chart-wrapper" }
const _hoisted_25 = { class: "chart-wrapper" }
const _hoisted_26 = { class: "chart-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Line = _resolveComponent("Line")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.acceptanceRateAverage.toFixed(2)) + "%", 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.cumulativeNumberSuggestions), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.cumulativeNumberAcceptances), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.cumulativeNumberLOCAccepted), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_container, { class: "charts-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "chart-card mb-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Acceptance rate (%)")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Bar, {
                data: _ctx.acceptanceRateChartData,
                options: _ctx.chartOptions
              }, null, 8, ["data", "options"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "chart-card mb-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Total Suggestions Count | Total Acceptances Count")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Line, {
                data: _ctx.totalSuggestionsAndAcceptanceChartData,
                options: _ctx.chartOptions
              }, null, 8, ["data", "options"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "chart-card mb-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Total Lines Suggested | Total Lines Accepted")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Line, {
                data: _ctx.chartData,
                options: _ctx.chartOptions
              }, null, 8, ["data", "options"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "chart-card mb-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Total Active Users")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Bar, {
                data: _ctx.totalActiveUsersChartData,
                options: _ctx.totalActiveUsersChartOptions
              }, null, 8, ["data", "options"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}